
<d-contract-edit
    v-model      = "edit"
    title        = "ZÜS"
    :type-id     = "typeId"
    :contract-id = "contractId"
    :company-id  = "companyId"
    @initialized = "onInitialized"
    @saved       = "onSaved"
>
    <!--
    <template v-slot:terms>
        <c-column-header
            class  = "primary mt-0"
            :label = "$t('contract.terms') "
        />

        <div class="lm-border pa-3 pt-0 mt-1">
            <c-contract-zus-terms
                :contract   = "contract"
                :readonly   = "false"
                :show-title = "false"
                class       = "pt-2"
                style       = "height: 694px"
            />
        </div>
    </template>
    -->
</d-contract-edit>
